import React, { useEffect, useState } from 'react'
import { Box, Card, CardContent, Checkbox, Divider, FormControl, InputLabel } from '@material-ui/core'
import { NotFound } from 'components/NotFound/NotFound'
import { useAuthStore } from 'context/AuthStore'
import { useStyles } from './card-checkbox.styles'

export const CardCheckbox = ({ data, line, columns = '2' }) => {
  const classes = useStyles()

  const { authStore } = useAuthStore()
  const [currentColumns, setCurrentColumns] = useState(authStore.isMobile ? '1' : columns)

  useEffect(() => {
    if (authStore.isMobile) {
      setCurrentColumns('1')
    } else {
      setCurrentColumns(columns)
    }
  }, [authStore.isMobile, columns])

  return (
    <Card variant="outlined" className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Box display="grid" gridTemplateColumns={`repeat(${currentColumns}, 1fr)`} gap={4}>
          {data ? (
            data.map((item, index) => (
              <React.Fragment key={index}>
                <Box className={classes.boxItem}>
                  <FormControl className={classes.checkbox}>
                    <Checkbox checked={item.value} color={'primary'} disabled={!item.value} />
                    <InputLabel
                      className={classes.checkboxLabel}
                      shrink
                      htmlFor={'clientRegistrationAddressEqualsActualAddress'}
                    >
                      {item.label}
                    </InputLabel>
                  </FormControl>
                </Box>
                {(index + 1) % 2 === 0 && line && index !== data?.length - 1 && (
                  <Box gridColumn={`span ${currentColumns}`} className={classes.divider}>
                    <Divider />
                  </Box>
                )}
              </React.Fragment>
            ))
          ) : (
            <NotFound />
          )}
        </Box>
      </CardContent>
    </Card>
  )
}
